module.exports = __webpack_public_path__ + "static/media/buildingsweden.d4de2b92.svg";